import { createSelector } from "reselect";
import orderByPosition from "./helpers/orderByPosition";

export const getQuestionStems = (state) => state.entities.questionStems || {};

const getQuestionId = (_, questionId) => questionId;
const getStemId = (_, stemId) => stemId;

export const getAllQuestionStems = createSelector(
  getQuestionStems,
  (stems) => Object.values(stems)
);

export const getQuestionStemsByQuestionId = createSelector(
  getQuestionStems,
  getQuestionId,
  (stems, questionId) =>
    Object.values(stems)
      .filter((stem) => {
        const stemQuestionId = stem.questionId;
        return stemQuestionId != null && Number(stemQuestionId) === Number(questionId);
      })
      .sort(orderByPosition)
);

export const getQuestionStemById = createSelector(
  getQuestionStems,
  getStemId,
  (stems, stemId) => stems[stemId]
);
